import {
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonText,
} from '@ionic/react';
import Trans from 'util/Trans';

const ErrorBox = ({ error }: { error: Error | string | null }) => {
  if (!error || error.toString() === '') return null;

  const msg = error instanceof Error ? error.message : error.toString();
  return (
    <IonCard color="danger">
      <IonCardHeader>
        <IonCardTitle>
          <Trans i18nKey="AN_ERROR_OCCURRED">Ein Fehler ist aufgetreten</Trans>
          ...
        </IonCardTitle>
      </IonCardHeader>
      <IonCardContent>
        <IonText>
          <pre>{msg}</pre>
        </IonText>
      </IonCardContent>
    </IonCard>
  );
};

export default ErrorBox;
